import useLocalStorageState from "use-local-storage-state";
import { EmissionsBySource } from "@labs/shared/types/EmissionsBySource.ts";

export const useLocalBaselineEmissionsState = () =>
  useLocalStorageState<EmissionsBySource>("baselineEmissions", {
    defaultValue: {
      electricity: 0,
      naturalGas: 0,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  });
